module.exports = __webpack_public_path__ + "static/img/why-3.24bccb16.jpg";